import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
export class ProfileService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
    }
    updatePassword(formData) {
        return this.http.put(`${environment.base_url}/auth/update_password`, formData);
    }
    uploadImage(base64) {
        return this.http.put(`${environment.base_url}/auth/upload_picture`, { picture: base64 }, {
            reportProgress: true,
            observe: 'events'
        });
    }
    uploadImg(payload) {
        return this.http.post(`${environment.base_url}/auth/upload`, payload, {
            reportProgress: true,
            observe: 'events'
        });
    }
    downloadFile(id) {
        return this.http.get(`${environment.base_url}/auth/picture/download_file/${id}`, {
            observe: 'response',
            responseType: 'blob'
        });
    }
    questIES(ies) {
        return this.http.get(`${environment.base_url}/quest_ies/${ies}`);
    }
    questCities(uf) {
        return this.http.get(`${environment.base_url}/get_cities/${uf}`);
    }
    getCountries() {
        return this.http.get(`${environment.base_url}/get_countries`);
    }
    store_student_affiliation(formData) {
        return this.http.post(`${environment.base_url}/users/add_student_affiliation`, formData);
    }
    update_student_affiliation(id, formData) {
        return this.http.put(`${environment.base_url}/users/student_institution/${id}/update`, formData);
    }
    update(form, userId) {
        return this.http.put(`${environment.base_url}/users/${userId}`, form);
    }
    checkChangedName(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/check_changed_name`);
    }
}
ProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfileService_Factory() { return new ProfileService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router)); }, token: ProfileService, providedIn: "root" });
